import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TarefaService} from "../../../services/tarefa-service";
import {TarefaDetalhes} from "../../../models/tarefa-detalhes";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {ListaUsuario} from "../../../../auth/models/lista-usuario";
import {UsuarioService} from "../../../../auth/services/usuario-service";
import {AtribuiTarefa} from "../../../models/atribui-tarefa";
import {StatusTarefa} from "../../../enums/status-tarefa";

@Component({
    selector: 'app-detalhes',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent {
  @Output() atualizarLista = new EventEmitter();
  @Input() telaProcesso = false;
  @Input() processoId: number;
  botaoSalvarAtivadade = false;
  botaoSalvarDescricao = false;
  modalDetalhes = false;
  showModalAtribuir = false;
  showModalModificarStatus = false;
  loading = false;
  tarefa = new TarefaDetalhes();
  usuarios = new ListaUsuario();
  statusEnum = StatusTarefa;
  statusAtualizar = 0;
  statusEnumKey = Object.keys(StatusTarefa).filter(key => !isNaN(Number(key)));
  statusLista: any[] = [];

  constructor(private tarefaService: TarefaService,
              private usuarioService: UsuarioService,
              private route: ActivatedRoute,
              private toastr: ToastrService) {
    this.buscarUsuarios();
    this.prepararStatusLista();
  }

  private prepararStatusLista() {
    this.statusLista = this.statusEnumKey.map(key => ({
      id: Number(key),
      descricao: (this.statusEnum as any)[Number(key)]
    }));
  }

  fecharModal(){
    this.modalDetalhes = false;
    this.showModalAtribuir = false;
    this.showModalModificarStatus = false;
  }

  showModalDetalhes(){
    this.modalDetalhes = true;
    this.loading = true;
  }

  modificarStatus(){
    this.loading = true;
    let atribuirModelo = this.preecherAtribuir();
    atribuirModelo.status = this.statusAtualizar;
    this.tarefaService.alterarStatus(atribuirModelo).subscribe(response => {
      if(response.sucesso){
        this.toastr.success('Status modificado com sucesso');
        this.acionarAtualizarLista();
        this.fecharModal();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  buscarDetalhesTarefa(id: number){
    if (!id) {
      this.loading = false;
      return;
    }
    this.tarefaService.buscarPorId(id).subscribe(response => {
      if(response.dados)
        this.tarefa = response.dados;
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  salvar(){
    this.tarefaService.alterar(this.tarefa).subscribe(response => {
      if(response.sucesso)
      {
        this.toastr.success('Salvo com sucesso');
        this.buscarDetalhesTarefa(this.tarefa.id);
        this.botaoSalvarDescricao = false;
        this.botaoSalvarAtivadade = false;
        this.tarefa.comentario = '';
      }
      else
        this.toastr.error(response.errors[0].mensagem);
    });
  }

  atribuir(){
    this.loading = true;
    let atribuirModelo = this.preecherAtribuir();
    this.tarefaService.atribuir(atribuirModelo).subscribe(response => {
      if(response.sucesso){
          this.toastr.success("Atribuido com sucesso");
          this.acionarAtualizarLista();
          this.fecharModal();
      }
    })
    this.showModalAtribuir = false;
    this.loading = false;
  }

  finalizar(){
    this.loading = true;
    let atribuirModelo = this.preecherAtribuir();
    this.tarefaService.finalizar(atribuirModelo).subscribe(response => {
      if(response.sucesso)
      {
        this.toastr.success("Finalizado com sucesso");
        this.acionarAtualizarLista();
        this.fecharModal();
      }
    });
    this.loading = false;
  }

  iniciar(){
    this.loading = true;
    let atribuirModelo = this.preecherAtribuir();
    this.tarefaService.iniciar(atribuirModelo).subscribe(response => {
      if(response.sucesso)
      {
        this.toastr.success("Iniciada a tarefa com sucesso");
        this.acionarAtualizarLista();
        this.fecharModal();
      }
    });
    this.loading = false;
  }

  preecherAtribuir(): AtribuiTarefa{
    let atribuirModelo = new AtribuiTarefa();
    atribuirModelo.id = this.tarefa.id;
    atribuirModelo.responsavelId = this.tarefa.responsavelId;
    atribuirModelo.status = this.tarefa.status;
    return atribuirModelo;
  }

  desativar(){
    this.tarefaService.deletar(this.tarefa.id).subscribe(response => {
      if(response.sucesso){
        this.toastr.success("Desativado com sucesso");
        this.acionarAtualizarLista();
        this.fecharModal();
      }
    });
    this.loading = false;
  }

  cancelar(){
    this.botaoSalvarDescricao = false;
    this.botaoSalvarAtivadade = false;
  }

  private acionarAtualizarLista(){
    this.atualizarLista.emit();
  }

  private buscarUsuarios(){
    this.usuarioService.selecionarLista().subscribe(response => {
      if(response.sucesso)
        this.usuarios = response.dados;
    });
  }

  protected readonly StatusTarefa = StatusTarefa;
  protected readonly Number = Number;
}
